export default __webpack_public_path__ + "static/media/arowolo.32d50866.png";